import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import { Button, Typography } from "@mui/material";
import "./showvavaka.scss";
import * as vavakaService from "../../../services/VavakaService";
import CardVavaka from "../../../components/Card/CardVavaka/CardVavaka";
import Swal from "sweetalert2";
import Spinner from "../../../components/Spinner/Spinner";
import SearchBar from "../../../components/Search/SearchBar";

const ShowVavaka = () => {
  const [vavaka, setVavaka] = useState();
  const [isLoading, setIsLoading] = useState(true);
  const [filterTitle, setFilterTitle] = useState("");

  useEffect(() => {
    vavakaService
      .getAllVavaka()
      .then((vavakas) => {
        setVavaka(vavakas);
        setIsLoading(false);
      })
      .catch((error) => {
        console.error(
          "Erreur lors du chargement des données Teny Zaraina :",
          error
        );
        setIsLoading(false);
      });
  }, []);

  const handleDelete = async (id) => {
    const isConfirmed = await Swal.fire({
      title: "Êtes-vous sûr de vouloir supprimer cette prière ?",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Oui, supprimer!",
      cancelButtonText: "Annuler",
    });

    if (isConfirmed.isConfirmed) {
      try {
        const response = await vavakaService.deleteVavakaById(id);
        if (response && response.status === 200) {
          Swal.fire("Prière supprimée !", "Suppression réussie", "success");
          let newVavaka = vavaka.filter((vavakas) => vavakas.id !== id);
          setVavaka(newVavaka);
        } else {
          Swal.fire("Erreur", "La suppression a échoué", "error");
        }
      } catch (error) {
        console.error("Erreur lors de la suppression du vavaka :", error);
        Swal.fire("Erreur", "Une erreur s'est produite", "error");
      }
    }
  };

  const handleSearch = (value) => {
    setFilterTitle(value);
  };

  return (
    <div className="theme-component">
      <div className="add-button">
        <Link to="/vavaka/addVavaka">
          <Button>Créer Vavaka</Button>
        </Link>
      </div>

      <div
        style={{
          display: "flex",
          justifyContent: "center",
          marginBottom: "15px",
        }}
      >
        <SearchBar onSearch={handleSearch} />
      </div>

      {isLoading ? (
        <Spinner />
      ) : (
        <div className="theme">
          {vavaka && vavaka.length > 0 ? (
            vavaka
              .filter((vavakas) =>
                vavakas.lohateny
                  .toLowerCase()
                  .includes(filterTitle.toLowerCase())
              )
              .map((vavakas) => (
                <CardVavaka
                  key={vavakas.id}
                  vavakas={vavakas}
                  handleDelete={() => handleDelete(vavakas.id)}
                />
              ))
          ) : (
            <Typography variant="h6">Il n'y a pas de Vavaka.</Typography>
          )}
        </div>
      )}
    </div>
  );
};

export default ShowVavaka;
